export const isIFrame = (
  input: HTMLElement | null
): input is HTMLIFrameElement => input !== null && input.tagName === "IFRAME"

export interface ShareTokenTypes {
  setStateRenderView: (newValue: string) => void
  isLoading?: boolean
  stateRenderView: string
}
